import * as React from 'react'
import { classNames } from './helpers'

export interface ChevronProps {
  /** Which way the arrow points. Defaults to `left`. */
  orientation?: 'left' | 'right';
  /** Extra class(es) on the outer container. */
  className?: string;
}

/**
 * The bare chevron glyph: a left-pointing arrow, rotated 180° when pointing right.
 * Self-contained (no wrapper, no spacing) so it drops into a scroll button as
 * readily as after a title — the single source of the path shared by {@link
 * Chevron} and the ScrollRow controls.
 */
export function ChevronGlyph ({ orientation = 'left' }: { orientation?: 'left' | 'right' }) {
  return (
    <svg viewBox='0 0 24 24' width='1em' height='1em' aria-hidden='true' focusable='false'>
      <path
        fill='currentColor'
        transform={orientation === 'right' ? 'rotate(180 12 12)' : undefined}
        d='M15.9 20.8c.1.1.3.2.5.2s.3-.1.5-.2c.3-.2.3-.7 0-.9L8.6 12l8.2-7.9c.3-.2.3-.7 0-.9s-.7-.2-.9 0l-8.7 8.4c-.3.2-.3.7 0 .9l8.7 8.3z'
      />
    </svg>
  )
}

/** A small directional arrow used after a Showcase title. */
export function Chevron ({ className, orientation = 'left' }: ChevronProps) {
  const classes = classNames('mlsg-chevron', className)
  return (
    <span className={classes}>
      <ChevronGlyph orientation={orientation} />
    </span>
  )
}
